/**
 * FUTURE: Start using this file for all form types instead of the global.types.ts file
 * in the be and the types file in the fe.
 */
export const FORM_TYPE = {
  AGEING: 'ageing',
  ACNE: 'acne',
  ALLERGIES: 'allergies',
  COLD_SORES: 'cold sores',
  COMPOUNDED_CANNABIS: 'compounded cannabis',
  CONTRACEPTIVE_PILL: 'contraceptive pill',
  MEDICINAL_CANNABIS: 'medicinal cannabis',
  NICOTINE: 'nicotine',
  ERECTILE_DYSFUNCTION: 'erectile dysfunction',
  HERPES: 'herpes',
  HAIR_LOSS: 'hair loss',
  SLEEP: 'sleep',
  SKINCARE: 'skincare',
  CHECKUP: 'checkup',
  WEIGHT_LOSS: 'weight loss',
} as const;

const { COMPOUNDED_CANNABIS, SKINCARE, ...formCategory } = FORM_TYPE;
export const FORM_CATEGORIES = { ...formCategory } as const;
export const FORM_CATEGORIES_LIST = Object.values(FORM_CATEGORIES);

export const { CHECKUP, ...healthCategory } = formCategory;
export const HEALTH_CATEGORIES = { ...healthCategory } as const;
export const HEALTH_CATEGORIES_LIST = Object.values(HEALTH_CATEGORIES);

export const { SLEEP, NICOTINE, ...activeHealthCategory } = healthCategory;
export const ACTIVE_HEALTH_CATEGORIES = { ...activeHealthCategory } as const;
export const ACTIVE_HEALTH_CATEGORIES_LIST = Object.values(ACTIVE_HEALTH_CATEGORIES);

export const CHECKUP_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  AWAITING_REVIEW: 'AWAITING_REVIEW',
  COMPLETED: 'COMPLETED',
} as const;

// CD-806: Disabled onboarding prompt emails — replaced by PostHog-based solution.
export const ONBOARDING_PROMPT_EMAILS_ENABLED = false;
